import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="critical-launch"
export default class extends Controller {
  static targets = [ 'toggle', 'count' ];

  toggleTargetConnected() {
    this.refresh();
  }

  refresh() {
    if( !this.hasToggleTarget || !this.hasCountTarget ) return;

    let queueCount = parseInt( this.toggleTarget.dataset.queueCount ) || 0,
        count = this.countTarget.rows ? this.countTarget.rows.length : ( parseInt( this.countTarget.value ) || 0 );

    this.toggleTarget.classList.toggle( 'hidden', count <= queueCount );
  }
}
